export const DUTCH = 'nl-NL'
export const ENGLISH = 'en-GB'
export const FRENCH = 'fr-FR'
export const GERMAN = 'de-DE'


export const nl = '/nl'
export const en = '/en'
export const fr = '/fr'
export const de = '/de'